import { Type } from 'class-transformer';
import { DimensionOptionResultDto } from '../../common/dimensions/dimension-option-result-dto';

export class APCreditApplicationTransactionItemResultDto {
    id: number;
    itemId: number;
    amount: number;
    openBalance: number;
    glAccountNumber: string;
    offsetGLAccountNumber: string;
    description: string;

    @Type(() => DimensionOptionResultDto)
    dimensions: Array<DimensionOptionResultDto>;
}
